module.exports = __webpack_public_path__ + "static/media/AddFolder.3ddcccd7.svg";